import { createAsyncThunk } from '@reduxjs/toolkit';

import { prepareLevelList } from '@/Module/Grade/Helper';
import type { IGetStrategyLevelInfoRequest } from '@/Module/Grade/Model/ApiModel';
import type { ILevel } from '@/Module/Grade/Model/DataModel';
import GradeService from '@/Module/Grade/Service/GradeService';

export const getStrategyLevelInfoAction = createAsyncThunk<ILevel[], IGetStrategyLevelInfoRequest>(
  'grade/getStrategyLevelInfo',
  async (req, { signal, rejectWithValue }) => {
    try {
      const response = await GradeService.getStrategyLevelInfo(req, signal);
      const data = response?.data?.data?.data;

      if (!data) return [];

      return prepareLevelList(data);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
